import { createApi } from '@reduxjs/toolkit/dist/query/react'

import { FeatureType } from 'clickNgo/configs/feature'
import { axiosProcedureQuery } from 'clickNgo/helpers/api'

export const MASTER_DEALER_TAG = 'MasterDealerTotalInfo'

export const masterDealerApi = createApi({
  reducerPath: `${FeatureType.P360Api}/masterDealerApi`,
  baseQuery: axiosProcedureQuery<any[]>(),
  tagTypes: [MASTER_DEALER_TAG],
  endpoints(build) {
    return {
      getMasterDealerTotalInfo: build.query<any, string>({
        providesTags: (result, error, partnerId) => [{ type: MASTER_DEALER_TAG, id: partnerId }],
        transformResponse(response: any) {
          if (response && response.Rows && response.Rows.length) {
            const [item] = response.Rows
            return item
          }
        },
        query(partnerId: string) {
          return {
            url: `/webservice/197/sp/v3/dbo.spJBPMasterDealerEPTotalInfo/call`,
            method: 'POST',
            data: {
              'p.PartnerID': partnerId,
            },
          }
        },
      }),
    }
  },
})

export const { useGetMasterDealerTotalInfoQuery } = masterDealerApi
